import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatCommonModule,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { ToFixedPipe } from '../pipes/to-fixed.pipe';
import { AlmacenInsumosRoutingModule } from './almacen-insumos-routing.module';
import { AlmacenInsumosComponent } from './almacen-insumos.component';
import { DialogAdditionalOutflowComponent } from './egreso/dialog-additional-outflow/dialog-additional-outflow.component';
import { DialogDeleteOutflowComponent } from './egreso/dialog-additional-outflow/dialog-delete-outflow/dialog-delete-outflow.component';
import { DialogCreateAdditionalOutflowComponent } from './egreso/dialog-create-additional-outflow/dialog-create-additional-outflow.component';
import { DialogEditOutflowObservationComponent } from './egreso/dialog-edit-outflow-observation/dialog-edit-outflow-observation.component';
import { DialogEgresoInsumoComponent } from './egreso/dialog-egreso-insumo/dialog-egreso-insumo.component';
import { DialogConfirmationComponent } from './egreso/dialog-evidence/dialog-confirmation/dialog-confirm.component';
import { DialogFoodOutflowEvidenceComponent } from './egreso/dialog-evidence/dialog-evidence.component';
import { DialogFileDetailComponent } from './egreso/dialog-file-detail/dialog-file-detail.component';
import { EgresoComponent } from './egreso/egreso.component';
import { EditObservacionComponent } from './egreso/table-expand/edit-observacion/edit-observacion.component';
import { EditTotalPaxComponent } from './egreso/table-expand/edit-total-pax/edit-total-pax.component';
import { ListaMultimediaComponent } from './egreso/table-expand/lista-multimedia/lista-multimedia.component';
import { TableExpandComponent } from './egreso/table-expand/table-expand.component';
import { DialogIngresoInsumoComponent } from './ingreso/dialog-ingreso-insumo/dialog-ingreso-insumo.component';
import { IngresoComponent } from './ingreso/ingreso.component';
import { InventarioComponent } from './inventario/inventario.component';
import { KardexComponent } from './kardex/kardex.component';

@NgModule({
  declarations: [
    EgresoComponent,
    IngresoComponent,
    InventarioComponent,
    KardexComponent,
    TableExpandComponent,
    EditTotalPaxComponent,
    AlmacenInsumosComponent,
    EditObservacionComponent,
    ListaMultimediaComponent,
    DialogFileDetailComponent,
    DialogConfirmationComponent,
    DialogEgresoInsumoComponent,
    DialogIngresoInsumoComponent,
    DialogAdditionalOutflowComponent,
    DialogFoodOutflowEvidenceComponent,
    DialogEditOutflowObservationComponent,
    DialogCreateAdditionalOutflowComponent,
    DialogDeleteOutflowComponent,
  ],
  imports: [
    ToFixedPipe,
    FormsModule,
    RouterModule,
    CommonModule,
    MatSortModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatTableModule,
    MatRadioModule,
    MatCommonModule,
    TextFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatFormFieldModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    AlmacenInsumosRoutingModule,
    TablerIconsModule.pick(TablerIcons),
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { autoActiveFirstOption: true },
    },
  ],
})
export class AlmacenInsumosModule {}
